import { Component, OnInit } from '@angular/core';
import { P4mIncidentsService } from '../../services/incidents/p4mIncidentsService';
import { Observable } from 'rxjs';
import {
  P4mCategory,
  P4mCauser,
  P4mIncident,
  P4mPriority,
  P4mReferenceObject,
} from '../../services/incidents/incident.models';
import { NotificationService } from '../../../../p4m/notification.service';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-create-incident',
  templateUrl: './create-incident.component.html',
  styleUrls: ['./create-incident.component.scss'],
})
export class CreateIncidentComponent implements OnInit {
  files: FileList;

  name: string;
  description: string;
  selectedCategory: P4mCategory;
  selectedSubcategory: P4mCategory;
  selectedPrio: P4mPriority;
  selectedCauserInternal: P4mCauser;
  selectedCauserExternal: P4mCauser;

  referenceObject$: Observable<P4mReferenceObject>;
  categories$: Observable<P4mCategory[]>;
  subcategories$: Observable<P4mCategory[]>;
  priorities$: Observable<P4mPriority[]>;
  causersInternal: Observable<P4mCauser[]>;
  causersExternal: Observable<P4mCauser[]>;

  incidentForm: FormGroup;

  constructor(
    private is: P4mIncidentsService,
    private ns: NotificationService,
    private ar: ActivatedRoute,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.referenceObject$ = this.is.loadReferenceObject(
      this.ar.snapshot.params.referenceId,
    );
    this.categories$ = this.is.loadCategories();
    this.priorities$ = this.is.loadPriorities();
    this.causersExternal = this.is.loadCausersExternal();
    this.causersInternal = this.is.loadCausersInternal();

    this.initForm();
  }

  initForm() {
    this.incidentForm = new FormGroup({
      selectedPrio: new FormControl(this.selectedPrio, [Validators.required]),
      selectedCategory: new FormControl(this.selectedCategory, [
        Validators.required,
      ]),
      selectedSubCategory: new FormControl(this.selectedSubcategory),
      selectedCauserInternal: new FormControl(this.selectedCauserInternal),
      selectedCauserExternal: new FormControl(this.selectedCauserExternal),
      name: new FormControl(this.name, [Validators.required]),
      description: new FormControl(this.description),
    });
  }

  onCategoryChanged(event) {
    this.subcategories$ = this.is.loadSubcategories(event.value.id);
  }

  onFileSelected(event) {
    this.files = event;
    console.log(this.files);
  }

  createIncident() {
    const incident: P4mIncident = {
      name: this.incidentForm.get('name').value,
      priority: this.incidentForm.get('selectedPrio').value?.id5,
      description: this.incidentForm.get('description').value,
      subCategory: this.incidentForm.get('selectedSubCategory').value?.id,
      mainCategory: this.incidentForm.get('selectedCategory').value?.id,
      internalCauser: this.incidentForm.get('selectedCauserInternal').value?.id,
      externalCauser: this.incidentForm.get('selectedCauserExternal').value?.id,
    };
    let files: File[] = null;
    if (this.files) {
      files = Array.from(this.files);
    }
    this.is
      .createIncident(this.ar.snapshot.params.referenceId, incident, files)
      .subscribe((incident) => {
        this.ns.showNotification(
          this.translate.instant('quality.createIncident.incidentCreated'),
        );
      });
  }
}
